import AudioRecorder from './AudioRecorder.container';

export default AudioRecorder;
